module.exports = __webpack_public_path__ + "static/shipper-2-6711abab8f69a0b35cd9ba3dada64cf8.png";